import { render, staticRenderFns } from "./RequestEducationalServiceInfo.vue?vue&type=template&id=70a8a212"
import script from "./RequestEducationalServiceInfo.vue?vue&type=script&lang=js"
export * from "./RequestEducationalServiceInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports